// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPeopleFullBodyCircleSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12zm9.997-3.5c1.035 0 1.874-.783 1.874-1.75S13.03 5 11.997 5c-1.035 0-1.874.783-1.874 1.75s.839 1.75 1.874 1.75zm.914 10.237a.371.371 0 0 0 .362.263h1.535c.225 0 .4-.184.372-.393l-.976-7.35 3.49-.61c.204-.036.338-.219.3-.409l-.277-1.376c-.038-.19-.234-.315-.437-.28l-4.316.756a4.857 4.857 0 0 1-1.927 0L6.72 8.582c-.203-.035-.4.09-.437.28l-.277 1.376c-.038.19.096.373.3.408l3.49.612-.976 7.349c-.027.209.147.393.372.393h1.535c.17 0 .32-.108.363-.263l.907-3.808z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPeopleFullBodyCircleSolid;
